import { render } from "./inventoryInit.vue?vue&type=template&id=bce69716&scoped=true"
import script from "./inventoryInit.vue?vue&type=script&lang=js"
export * from "./inventoryInit.vue?vue&type=script&lang=js"

import "./inventoryInit.vue?vue&type=style&index=0&id=bce69716&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce69716"]])

export default __exports__